// src/app/page.tsx
import { FC, ReactNode, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Modal,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { CustomButton } from "./Button";
import { CiCircleQuestion } from "react-icons/ci";
import { tokensCost } from "../utils/functions";
import AirHorn from "../assets/images/air-horn 1.png";
import Celebrate from "../assets/images/celebrate.gif";

export const SubscriptionDialog = ({
  handleClose,
  open,
  title,
  content,
  btn1,
  handleBtn1 = () => {},
  icon = undefined,
  bgimage = false,
  cancel,
  airhorn = false,
  height = "auto",
  width = "auto",
  btncolor = "#218F54",
  subContent = "",
  cancelText = "",
}: {
  handleClose?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  handleBtn1?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  open: boolean;
  title: string;
  content: string;
  btn1: string;
  icon?: ReactNode;
  bgimage?: boolean;
  cancel?: () => void | undefined;
  airhorn?: boolean;
  height: string;
  width: string;
  subContent: string;
  cancelText: string;
  btncolor: string;
}) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "#C7FFB3 !important",
          //   backgroundImage: "initial",
          textAlign: "center",
          width: { xs: "80%", sm: width },
          height: { sm: height },
          boxShadow: "0 0 5px #222 !important",
          borderRadius: "10px",
          padding: "10px 30px",
          backgroundImage: bgimage
            ? `
        url(${Celebrate})
      `
            : "none",
          backgroundSize: bgimage ? "cover" : "",
          backgroundPosition: bgimage ? "center" : "",
          backgroundRepeat: bgimage ? "no-repeat" : "",
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        color={"#2C4A3A"}
        sx={{
          fontWeight: 600,
          fontFamily: "Poppins !important",
          fontSize: "32px",
        }}
      >
        <div>
          {airhorn ? (
            <img src={AirHorn} style={{ width: "230px", height: "230px" }} />
          ) : null}
          <div
            style={{
              lineHeight: 1,
              display: "flex",
              gap: "5px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {title}
            {icon}
          </div>
        </div>
      </DialogTitle>
      {content && (
        <DialogContent sx={{ padding: "0px !important" }}>
          <Typography
            component="div"
            textAlign={"center"}
            fontWeight={"400"}
            color={
              title == "WARNING" || title == "Confirmation"
                ? "initial"
                : "secondary"
            }
            fontSize={"20px"}
            letterSpacing={"0.25px"}
            fontFamily={"Poppins"}
          >
            {content}
          </Typography>
          {subContent ? (
            <div
              style={{
                fontSize: "16px",
                color: "#C7503D",
                letterSpacing: "0.25px",
                margin: "10px 0px",
              }}
              dangerouslySetInnerHTML={{ __html: subContent }}
            ></div>
          ) : null}
        </DialogContent>
      )}
      {btn1 ? (
        <DialogActions
          sx={{
            padding: "10px !important",
            gap: { xs: "5px", sm: "0px" },
            justifyContent: "center",
          }}
        >
          <div style={{ minWidth: "70%" }}>
            <CustomButton
              text={btn1}
              color={"white"}
              bgcolor={btncolor}
              submit={handleBtn1}
              fontWeight="600"
              width="100%"
              height="50px"
              borderRadius="22px"
            />
          </div>
        </DialogActions>
      ) : null}
      {cancel && (
        <div
          style={{
            fontSize: "16px",
            color: "#C7503D",
            letterSpacing: "0.25px",
            margin: "10px 0px",
            cursor: "pointer",
          }}
          onClick={cancel}
        >
          {cancelText}
        </div>
      )}
    </Dialog>
  );
};
